import React, { useContext, createContext, useState, createRef, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoSquare, faExclamationTriangle, faTimesCircle } from '@fortawesome/pro-solid-svg-icons';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}var AsyncMode=l;var ConcurrentMode=m;var ContextConsumer=k;var ContextProvider=h;var Element=c;var ForwardRef=n;var Fragment$1=e;var Lazy=t;var Memo=r;var Portal=d;
var Profiler=g;var StrictMode=f;var Suspense=p;var isAsyncMode=function(a){return A(a)||z(a)===l};var isConcurrentMode=A;var isContextConsumer=function(a){return z(a)===k};var isContextProvider=function(a){return z(a)===h};var isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};var isForwardRef=function(a){return z(a)===n};var isFragment=function(a){return z(a)===e};var isLazy=function(a){return z(a)===t};
var isMemo=function(a){return z(a)===r};var isPortal=function(a){return z(a)===d};var isProfiler=function(a){return z(a)===g};var isStrictMode=function(a){return z(a)===f};var isSuspense=function(a){return z(a)===p};
var isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};var typeOf=z;

var reactIs_production_min = {
	AsyncMode: AsyncMode,
	ConcurrentMode: ConcurrentMode,
	ContextConsumer: ContextConsumer,
	ContextProvider: ContextProvider,
	Element: Element,
	ForwardRef: ForwardRef,
	Fragment: Fragment$1,
	Lazy: Lazy,
	Memo: Memo,
	Portal: Portal,
	Profiler: Profiler,
	StrictMode: StrictMode,
	Suspense: Suspense,
	isAsyncMode: isAsyncMode,
	isConcurrentMode: isConcurrentMode,
	isContextConsumer: isContextConsumer,
	isContextProvider: isContextProvider,
	isElement: isElement,
	isForwardRef: isForwardRef,
	isFragment: isFragment,
	isLazy: isLazy,
	isMemo: isMemo,
	isPortal: isPortal,
	isProfiler: isProfiler,
	isStrictMode: isStrictMode,
	isSuspense: isSuspense,
	isValidElementType: isValidElementType,
	typeOf: typeOf
};

var reactIs_development = createCommonjsModule(function (module, exports) {



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}
});

var reactIs = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min;
} else {
  module.exports = reactIs_development;
}
});

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret;

var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes;

var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning$1(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has$1(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$1(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = factoryWithThrowingShims();
}
});

function BaseButton(_ref) {
  var variant = _ref.variant,
      type = _ref.type,
      size = _ref.size,
      onClick = _ref.onClick,
      href = _ref.href,
      disabled = _ref.disabled,
      ariaControls = _ref.ariaControls,
      children = _ref.children;
  var buttonVariant = variant !== '' ? 'hw-button--' + variant : '';
  var buttonSize = size ? 'hw-button--' + size : '';

  if (href) {
    return /*#__PURE__*/React.createElement("a", {
      href: href,
      className: "hw-button " + buttonVariant + " " + buttonSize,
      onClick: onClick,
      disabled: disabled
    }, children);
  } else {
    return /*#__PURE__*/React.createElement("button", {
      type: type,
      className: "hw-button " + buttonVariant + " " + buttonSize,
      onClick: onClick,
      disabled: disabled,
      "aria-controls": ariaControls
    }, children);
  }
}
BaseButton.defaultProps = {
  variant: '',
  type: 'button',
  disabled: false
};
BaseButton.propTypes = {
  variant: propTypes.oneOf(['', 'chat', 'chat-fixed', 'primary', 'secondary', 'outline-primary', 'outline-secondary', 'outline-white']),
  type: propTypes.oneOf(['button', 'submit']),
  size: propTypes.oneOf(['small', 'medium', 'large', 'full', 'mobile-full']),
  onClick: propTypes.func,
  disabled: propTypes.bool,
  ariaControls: propTypes.string,
  href: propTypes.string
};

function PrimaryButton(_ref) {
  var type = _ref.type,
      size = _ref.size,
      onClick = _ref.onClick,
      href = _ref.href,
      disabled = _ref.disabled,
      ariaControls = _ref.ariaControls,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(BaseButton, {
    variant: "primary",
    type: type,
    size: size,
    disabled: disabled,
    ariaControls: ariaControls,
    onClick: onClick,
    href: href
  }, children);
}
PrimaryButton.defaultProps = {
  disabled: false,
  type: 'button'
};
PrimaryButton.propTypes = {
  size: propTypes.oneOf(['small', 'medium', 'large', 'full', 'mobile-full']),
  type: propTypes.oneOf(['button', 'submit']),
  onClick: propTypes.func,
  disabled: propTypes.bool,
  ariaControls: propTypes.string,
  href: propTypes.string
};

function SecondaryButton(_ref) {
  var type = _ref.type,
      size = _ref.size,
      onClick = _ref.onClick,
      href = _ref.href,
      disabled = _ref.disabled,
      ariaControls = _ref.ariaControls,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(BaseButton, {
    variant: "secondary",
    type: type,
    size: size,
    disabled: disabled,
    ariaControls: ariaControls,
    onClick: onClick,
    href: href
  }, children);
}
SecondaryButton.defaultProps = {
  disabled: false,
  type: 'button'
};
SecondaryButton.propTypes = {
  size: propTypes.oneOf(['small', 'medium', 'large', 'full', 'mobile-full']),
  type: propTypes.oneOf(['button', 'submit']),
  onClick: propTypes.func,
  disabled: propTypes.bool,
  ariaControls: propTypes.string,
  href: propTypes.string
};

function PrimaryOutlineButton(_ref) {
  var type = _ref.type,
      size = _ref.size,
      onClick = _ref.onClick,
      href = _ref.href,
      disabled = _ref.disabled,
      ariaControls = _ref.ariaControls,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(BaseButton, {
    variant: "outline-primary",
    type: type,
    size: size,
    disabled: disabled,
    ariaControls: ariaControls,
    onClick: onClick,
    href: href
  }, children);
}
PrimaryOutlineButton.defaultProps = {
  disabled: false,
  type: 'button'
};
PrimaryOutlineButton.propTypes = {
  size: propTypes.oneOf(['small', 'medium', 'large', 'full', 'mobile-full']),
  type: propTypes.oneOf(['button', 'submit']),
  onClick: propTypes.func,
  disabled: propTypes.bool,
  ariaControls: propTypes.string,
  href: propTypes.string
};

function SecondaryOutlineButton(_ref) {
  var type = _ref.type,
      size = _ref.size,
      onClick = _ref.onClick,
      href = _ref.href,
      disabled = _ref.disabled,
      ariaControls = _ref.ariaControls,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(BaseButton, {
    variant: "outline-secondary",
    type: type,
    size: size,
    disabled: disabled,
    ariaControls: ariaControls,
    onClick: onClick,
    href: href
  }, children);
}
SecondaryOutlineButton.defaultProps = {
  disabled: false,
  type: 'button'
};
SecondaryOutlineButton.propTypes = {
  size: propTypes.oneOf(['small', 'medium', 'large', 'full', 'mobile-full']),
  type: propTypes.oneOf(['button', 'submit']),
  onClick: propTypes.func,
  disabled: propTypes.bool,
  ariaControls: propTypes.string,
  href: propTypes.string
};

function LightOutlineButton(_ref) {
  var type = _ref.type,
      size = _ref.size,
      onClick = _ref.onClick,
      href = _ref.href,
      disabled = _ref.disabled,
      ariaControls = _ref.ariaControls,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(BaseButton, {
    variant: "outline-white",
    type: type,
    size: size,
    disabled: disabled,
    ariaControls: ariaControls,
    onClick: onClick,
    href: href
  }, children);
}
LightOutlineButton.defaultProps = {
  disabled: false,
  type: 'button'
};
LightOutlineButton.propTypes = {
  size: propTypes.oneOf(['small', 'medium', 'large', 'full', 'mobile-full']),
  type: propTypes.oneOf(['button', 'submit']),
  onClick: propTypes.func,
  disabled: propTypes.bool,
  ariaControls: propTypes.string,
  href: propTypes.string
};

function BaseDropdown(_ref) {
  var label = _ref.label,
      name = _ref.name,
      variant = _ref.variant,
      id = _ref.id,
      selected = _ref.selected,
      onChange = _ref.onChange,
      options = _ref.options,
      errorMessage = _ref.errorMessage,
      ariaControls = _ref.ariaControls;
  var variation = variant == 'white' ? 'hw-dropdown--white' : '';
  var labelVariation = variant === 'line' ? 'hw-label--line' : '';

  if (errorMessage !== '') {
    variation += ' hw-input--error';
    labelVariation += ' hw-label--error';
  }

  var items = '';

  if (options) {
    items = options.map(function (item, index) {
      return /*#__PURE__*/React.createElement("option", {
        value: item.value,
        key: index
      }, ' ', item.label, ' ');
    });
  }

  return /*#__PURE__*/React.createElement("label", {
    className: "hw-label " + labelVariation
  }, label, /*#__PURE__*/React.createElement("select", {
    name: name,
    className: "hw-dropdown hw-dropdown--native " + variation,
    id: id,
    value: selected,
    "data-hw-dropdown": id,
    onChange: onChange,
    "aria-controls": ariaControls
  }, items), errorMessage && /*#__PURE__*/React.createElement("div", {
    className: "hw-error hw-error--align-left hw-error--indented"
  }, errorMessage));
}
BaseDropdown.defaultProps = {
  variant: '',
  options: [],
  errorMessage: ''
};
BaseDropdown.propTypes = {
  label: propTypes.string,
  id: propTypes.string,
  variant: propTypes.oneOf(['', 'white', 'line']),
  errorMessage: propTypes.string,
  onChange: propTypes.func,
  ariaControls: propTypes.string
};

function Dropdown(_ref) {
  var label = _ref.label,
      name = _ref.name,
      variant = _ref.variant,
      id = _ref.id,
      selected = _ref.selected,
      onChange = _ref.onChange,
      options = _ref.options,
      errorMessage = _ref.errorMessage,
      ariaControls = _ref.ariaControls;
  return /*#__PURE__*/React.createElement(BaseDropdown, {
    variant: variant,
    label: label,
    name: name,
    id: id,
    selected: selected,
    onChange: onChange,
    options: options,
    errorMessage: errorMessage,
    ariaControls: ariaControls
  });
}
Dropdown.propTypes = {
  name: propTypes.string,
  label: propTypes.string,
  id: propTypes.string,
  variant: propTypes.oneOf(['', 'white', 'line']),
  onChange: propTypes.func,
  errorMessage: propTypes.string,
  ariaControls: propTypes.string
};

function BaseBadge(_ref) {
  var variant = _ref.variant,
      size = _ref.size,
      children = _ref.children;
  return /*#__PURE__*/React.createElement("span", {
    className: "hw-badge " + (size ? 'hw-badge--' + size : '') + " " + (variant ? 'hw-badge--' + variant : '')
  }, children);
}
BaseBadge.propTypes = {
  variant: propTypes.oneOf(['dark', 'white', 'warning']),
  size: propTypes.oneOf(['smaller', 'small', 'large', 'larger'])
};

function Badge(_ref) {
  var size = _ref.size,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(BaseBadge, {
    size: size
  }, children);
}
Badge.propTypes = {
  size: propTypes.oneOf(['smaller', 'small', 'large', 'larger'])
};

function DarkBadge(_ref) {
  var size = _ref.size,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(BaseBadge, {
    variant: "dark",
    size: size
  }, children);
}
DarkBadge.propTypes = {
  size: propTypes.oneOf(['smaller', 'small', 'large', 'larger'])
};

function WarningBadge(_ref) {
  var size = _ref.size,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(BaseBadge, {
    variant: "warning",
    size: size
  }, children);
}
WarningBadge.propTypes = {
  size: propTypes.oneOf(['smaller', 'small', 'large', 'larger'])
};

function WhiteBadge(_ref) {
  var size = _ref.size,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(BaseBadge, {
    variant: "white",
    size: size
  }, children);
}
WhiteBadge.propTypes = {
  size: propTypes.oneOf(['smaller', 'small', 'large', 'larger'])
};

function BaseInput(_ref) {
  var name = _ref.name,
      id = _ref.id,
      label = _ref.label,
      placeholder = _ref.placeholder,
      type = _ref.type,
      min = _ref.min,
      max = _ref.max,
      steps = _ref.steps,
      disabled = _ref.disabled,
      maxLength = _ref.maxLength,
      variant = _ref.variant,
      errorMessage = _ref.errorMessage,
      onChange = _ref.onChange,
      readOnly = _ref.readOnly,
      ref = _ref.ref;
  var variation = variant !== '' ? 'hw-input--' + variant : '';
  var labelVariation = variant === 'line' ? 'hw-label--line' : '';

  if (errorMessage !== '') {
    variation += ' hw-input--error';
    labelVariation += ' hw-label--error';
  }

  return /*#__PURE__*/React.createElement("label", {
    className: 'hw-label ' + labelVariation
  }, label, /*#__PURE__*/React.createElement("input", {
    name: name,
    id: id,
    className: 'hw-input ' + variation,
    type: type,
    min: min,
    max: max,
    steps: steps,
    placeholder: placeholder,
    disabled: disabled,
    maxLength: maxLength,
    onChange: onChange,
    readOnly: readOnly,
    ref: ref
  }), errorMessage && /*#__PURE__*/React.createElement("div", {
    className: "hw-error hw-error--align-left hw-error--indented"
  }, errorMessage));
}
BaseInput.defaultProps = {
  disabled: false,
  type: 'text',
  errorMessage: '',
  variant: ''
};
BaseInput.propTypes = {
  name: propTypes.string,
  id: propTypes.string,
  type: propTypes.oneOf(['text', 'number', 'password', 'email']),
  onChange: propTypes.func,
  variant: propTypes.oneOf(['white', 'line', '']),
  maxLength: propTypes.number,
  errorMessage: propTypes.string,
  placeholder: propTypes.string,
  label: propTypes.string,
  disabled: propTypes.bool,
  readOnly: propTypes.bool
};

function TextInput(_ref) {
  var name = _ref.name,
      id = _ref.id,
      label = _ref.label,
      placeholder = _ref.placeholder,
      disabled = _ref.disabled,
      maxLength = _ref.maxLength,
      errorMessage = _ref.errorMessage,
      variant = _ref.variant,
      onChange = _ref.onChange,
      readOnly = _ref.readOnly;
  return /*#__PURE__*/React.createElement(BaseInput, {
    name: name,
    id: id,
    label: label,
    type: "text",
    variant: variant,
    placeholder: placeholder,
    maxLength: maxLength,
    disabled: disabled,
    onChange: onChange,
    errorMessage: errorMessage,
    readOnly: readOnly
  });
}
TextInput.defaultProps = {
  disabled: false
};
TextInput.propTypes = {
  name: propTypes.string,
  id: propTypes.string,
  variant: propTypes.oneOf(['', 'white', 'line']),
  disabled: propTypes.bool,
  readOnly: propTypes.bool,
  maxLength: propTypes.number,
  onChange: propTypes.func,
  errorMessage: propTypes.string,
  placeholder: propTypes.string,
  label: propTypes.string
};

function NumberInput(_ref) {
  var name = _ref.name,
      id = _ref.id,
      label = _ref.label,
      placeholder = _ref.placeholder,
      min = _ref.min,
      max = _ref.max,
      steps = _ref.steps,
      variant = _ref.variant,
      disabled = _ref.disabled,
      errorMessage = _ref.errorMessage,
      onChange = _ref.onChange,
      readOnly = _ref.readOnly;
  return /*#__PURE__*/React.createElement(BaseInput, {
    name: name,
    id: id,
    variant: variant,
    label: label,
    type: "number",
    min: min,
    max: max,
    steps: steps,
    placeholder: placeholder,
    disabled: disabled,
    onChange: onChange,
    errorMessage: errorMessage,
    readOnly: readOnly
  });
}
NumberInput.defaultProps = {
  disabled: false
};
NumberInput.propTypes = {
  name: propTypes.string,
  id: propTypes.string,
  variant: propTypes.oneOf(['', 'white', 'line']),
  disabled: propTypes.bool,
  readOnly: propTypes.bool,
  onChange: propTypes.func,
  errorMessage: propTypes.string,
  placeholder: propTypes.string,
  label: propTypes.string,
  min: propTypes.number,
  max: propTypes.number
};

function PasswordInput(_ref) {
  var name = _ref.name,
      id = _ref.id,
      label = _ref.label,
      placeholder = _ref.placeholder,
      variant = _ref.variant,
      disabled = _ref.disabled,
      errorMessage = _ref.errorMessage,
      onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(BaseInput, {
    name: name,
    id: id,
    variant: variant,
    label: label,
    type: "password",
    placeholder: placeholder,
    disabled: disabled,
    onChange: onChange,
    errorMessage: errorMessage
  });
}
PasswordInput.defaultProps = {
  disabled: false,
  type: 'text'
};
PasswordInput.propTypes = {
  name: propTypes.string,
  id: propTypes.string,
  variant: propTypes.oneOf(['', 'white', 'line']),
  disabled: propTypes.bool,
  onChange: propTypes.func,
  errorMessage: propTypes.string,
  placeholder: propTypes.string,
  label: propTypes.string
};

function BaseTextarea(_ref) {
  var id = _ref.id,
      name = _ref.name,
      label = _ref.label,
      variant = _ref.variant,
      placeholder = _ref.placeholder,
      rows = _ref.rows,
      cols = _ref.cols,
      maxLength = _ref.maxLength,
      onChange = _ref.onChange,
      disabled = _ref.disabled,
      readOnly = _ref.readOnly,
      errorMessage = _ref.errorMessage,
      children = _ref.children;
  var labelVariant = variant === 'line' ? 'hw-label--line' : '';
  var variation = variant !== '' ? 'hw-textarea--' + variant : '';

  if (errorMessage !== '') {
    labelVariant += ' hw-label--error';
    variation += ' hw-textarea--error';
  }

  return /*#__PURE__*/React.createElement("label", {
    className: 'hw-label ' + labelVariant
  }, label, /*#__PURE__*/React.createElement("textarea", {
    id: id,
    name: name,
    className: 'hw-textarea ' + variation,
    rows: rows,
    cols: cols,
    maxLength: maxLength,
    placeholder: placeholder,
    onChange: onChange,
    disabled: disabled,
    readOnly: readOnly
  }, children), errorMessage && /*#__PURE__*/React.createElement("div", {
    className: "hw-error hw-error--align-left"
  }, errorMessage));
}
BaseTextarea.defaultProps = {
  variant: '',
  errorMessage: ''
};
BaseTextarea.propTypes = {
  name: propTypes.string,
  label: propTypes.string,
  variant: propTypes.oneOf(['white', 'line', '']),
  placeholder: propTypes.string,
  rows: propTypes.number,
  cols: propTypes.number,
  maxLength: propTypes.number,
  onChange: propTypes.func,
  disabled: propTypes.bool,
  readOnly: propTypes.bool,
  errorMessage: propTypes.string
};

function Textarea(_ref) {
  var id = _ref.id,
      name = _ref.name,
      label = _ref.label,
      variant = _ref.variant,
      placeholder = _ref.placeholder,
      rows = _ref.rows,
      cols = _ref.cols,
      maxLength = _ref.maxLength,
      onChange = _ref.onChange,
      disabled = _ref.disabled,
      readOnly = _ref.readOnly,
      errorMessage = _ref.errorMessage,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(BaseTextarea, {
    id: id,
    name: name,
    label: label,
    variant: variant,
    placeholder: placeholder,
    rows: rows,
    cols: cols,
    maxLength: maxLength,
    onChange: onChange,
    disabled: disabled,
    readOnly: readOnly,
    errorMessage: errorMessage
  }, children);
}
Textarea.propTypes = {
  name: propTypes.string,
  label: propTypes.string,
  variant: propTypes.oneOf(['white', 'line', '']),
  placeholder: propTypes.string,
  rows: propTypes.number,
  cols: propTypes.number,
  maxLength: propTypes.number,
  onChange: propTypes.func,
  disabled: propTypes.bool,
  readOnly: propTypes.bool,
  errorMessage: propTypes.string
};

function EmailInput(_ref) {
  var name = _ref.name,
      id = _ref.id,
      label = _ref.label,
      placeholder = _ref.placeholder,
      disabled = _ref.disabled,
      maxLength = _ref.maxLength,
      errorMessage = _ref.errorMessage,
      variant = _ref.variant,
      onChange = _ref.onChange,
      readOnly = _ref.readOnly;
  return /*#__PURE__*/React.createElement(BaseInput, {
    name: name,
    id: id,
    label: label,
    type: "email",
    variant: variant,
    placeholder: placeholder,
    maxLength: maxLength,
    disabled: disabled,
    onChange: onChange,
    errorMessage: errorMessage,
    readOnly: readOnly
  });
}
EmailInput.defaultProps = {
  disabled: false
};
EmailInput.propTypes = {
  name: propTypes.string,
  id: propTypes.string,
  variant: propTypes.oneOf(['', 'white', 'line']),
  disabled: propTypes.bool,
  readOnly: propTypes.bool,
  maxLength: propTypes.number,
  onChange: propTypes.func,
  errorMessage: propTypes.string,
  placeholder: propTypes.string,
  label: propTypes.string
};

var FieldsetContext = React.createContext();
var FieldsetProvider = FieldsetContext.Provider;

function BaseCheckbox(_ref) {
  var name = _ref.name,
      label = _ref.label,
      value = _ref.value,
      checked = _ref.checked,
      disabled = _ref.disabled,
      variants = _ref.variants,
      errorMessage = _ref.errorMessage,
      required = _ref.required,
      onClick = _ref.onClick;
  var classes = 'hw-checkbox';

  if (variants) {
    variants.forEach(function (element) {
      classes += ' hw-checkbox--' + element;
    });
  }

  if (errorMessage) {
    classes += ' hw-checkbox--error';
  }

  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("label", {
    className: classes
  }, label, /*#__PURE__*/React.createElement("input", {
    name: name,
    type: "checkbox",
    value: value,
    defaultChecked: checked,
    disabled: disabled,
    required: required,
    onClick: onClick
  }), /*#__PURE__*/React.createElement("i", {
    className: "hw-checkbox__indicator"
  })), errorMessage && /*#__PURE__*/React.createElement("div", {
    className: "hw-error-simple hw-error--align-left"
  }, errorMessage));
}
BaseCheckbox.defaultProps = {
  errorMessage: '',
  checked: false,
  disabled: false
};
BaseCheckbox.propTypes = {
  name: propTypes.string,
  label: propTypes.string,
  value: propTypes.string,
  checked: propTypes.bool,
  disabled: propTypes.bool,
  variants: propTypes.arrayOf(propTypes.oneOf(['bounding', 'full', 'horisontal'])),
  errorMessage: propTypes.string,
  required: propTypes.bool,
  onClick: propTypes.func
};

function Checkbox(_ref) {
  var name = _ref.name,
      label = _ref.label,
      value = _ref.value,
      checked = _ref.checked,
      disabled = _ref.disabled,
      errorMessage = _ref.errorMessage,
      required = _ref.required,
      onClick = _ref.onClick;
  var variants = useContext(FieldsetContext);
  var classes = [];

  if (variants) {
    var selectionControls = variants.find(function (x) {
      return x.name === 'selectionControls';
    });
    selectionControls.value.forEach(function (element) {
      classes.push(element);
    });
  }

  return /*#__PURE__*/React.createElement(BaseCheckbox, {
    name: name,
    label: label,
    value: value,
    checked: checked,
    disabled: disabled,
    variants: classes,
    errorMessage: errorMessage,
    required: required,
    onClick: onClick
  });
}
Checkbox.defaultProps = {
  errorMessage: '',
  checked: false
};
Checkbox.propTypes = {
  name: propTypes.string,
  label: propTypes.string,
  value: propTypes.string,
  checked: propTypes.bool,
  disabled: propTypes.bool,
  errorMessage: propTypes.string,
  required: propTypes.bool,
  onClick: propTypes.func
};

function BoundingCheckbox(_ref) {
  var name = _ref.name,
      label = _ref.label,
      value = _ref.value,
      checked = _ref.checked,
      disabled = _ref.disabled,
      errorMessage = _ref.errorMessage,
      required = _ref.required,
      onClick = _ref.onClick;
  var variants = useContext(FieldsetContext);
  var classes = ['bounding'];

  if (variants) {
    var selectionControls = variants.find(function (x) {
      return x.name === 'selectionControls';
    });
    selectionControls.value.forEach(function (element) {
      classes.push(element);
    });
  }

  return /*#__PURE__*/React.createElement(BaseCheckbox, {
    name: name,
    label: label,
    value: value,
    checked: checked,
    disabled: disabled,
    variants: classes,
    errorMessage: errorMessage,
    required: required,
    onClick: onClick
  });
}
BoundingCheckbox.propTypes = {
  name: propTypes.string,
  label: propTypes.string,
  value: propTypes.string,
  checked: propTypes.bool,
  disabled: propTypes.bool,
  errorMessage: propTypes.string,
  required: propTypes.bool,
  onClick: propTypes.func
};

function BaseRadioButton(_ref) {
  var name = _ref.name,
      label = _ref.label,
      value = _ref.value,
      disabled = _ref.disabled,
      variants = _ref.variants,
      errorMessage = _ref.errorMessage,
      required = _ref.required,
      defaultChecked = _ref.defaultChecked,
      onClick = _ref.onClick;
  var classes = 'hw-radio-button';

  if (variants) {
    variants.forEach(function (element) {
      classes += ' hw-radio-button--' + element;
    });
  }

  if (errorMessage) {
    classes += ' hw-radio-button--error';
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", {
    className: classes
  }, /*#__PURE__*/React.createElement("input", {
    type: "radio",
    name: name,
    value: value,
    disabled: disabled,
    onClick: onClick,
    required: required,
    defaultChecked: defaultChecked
  }), /*#__PURE__*/React.createElement("span", {
    className: "hw-radio-button__label"
  }, label), /*#__PURE__*/React.createElement("i", {
    className: "hw-radio-button__indicator"
  })), errorMessage && /*#__PURE__*/React.createElement("div", {
    className: "hw-error-simple hw-error--align-left"
  }, errorMessage));
}
BaseRadioButton.defaultProps = {
  errorMessage: '',
  disabled: false
};
BaseRadioButton.propTypes = {
  name: propTypes.string,
  label: propTypes.string,
  value: propTypes.string,
  disabled: propTypes.bool,
  variants: propTypes.arrayOf(propTypes.oneOf(['bounding', 'full', 'horisontal'])),
  required: propTypes.bool,
  defaultChecked: propTypes.bool,
  errorMessage: propTypes.string,
  onClick: propTypes.func
};

function RadioButton(_ref) {
  var name = _ref.name,
      label = _ref.label,
      value = _ref.value,
      disabled = _ref.disabled,
      errorMessage = _ref.errorMessage,
      required = _ref.required,
      defaultChecked = _ref.defaultChecked,
      onClick = _ref.onClick;
  var variants = useContext(FieldsetContext);
  var classes = [];

  if (variants) {
    var selectionControls = variants.find(function (x) {
      return x.name === 'selectionControls';
    });
    selectionControls.value.forEach(function (element) {
      classes.push(element);
    });
  }

  return /*#__PURE__*/React.createElement(BaseRadioButton, {
    name: name,
    label: label,
    value: value,
    disabled: disabled,
    variants: classes,
    errorMessage: errorMessage,
    required: required,
    defaultChecked: defaultChecked,
    onClick: onClick
  });
}
RadioButton.defaultProps = {
  errorMessage: ''
};
RadioButton.propTypes = {
  name: propTypes.string,
  label: propTypes.string,
  value: propTypes.string,
  disabled: propTypes.bool,
  requred: propTypes.bool,
  defaultChecked: propTypes.bool,
  errorMessage: propTypes.string,
  onClick: propTypes.func
};

function BoundingRadioButton(_ref) {
  var name = _ref.name,
      label = _ref.label,
      value = _ref.value,
      disabled = _ref.disabled,
      errorMessage = _ref.errorMessage,
      required = _ref.required,
      defaultChecked = _ref.defaultChecked,
      onClick = _ref.onClick;
  var classes = ['bounding'];
  return /*#__PURE__*/React.createElement(BaseRadioButton, {
    name: name,
    label: label,
    value: value,
    disabled: disabled,
    variants: classes,
    errorMessage: errorMessage,
    required: required,
    defaultChecked: defaultChecked,
    onClick: onClick
  });
}
BoundingRadioButton.defaultProps = {
  errorMessage: ''
};
BoundingRadioButton.propTypes = {
  name: propTypes.string,
  label: propTypes.string,
  value: propTypes.string,
  disabled: propTypes.bool,
  required: propTypes.bool,
  defaultChecked: propTypes.bool,
  errorMessage: propTypes.string,
  onClick: propTypes.func
};

function RadioButtonGroup(_ref) {
  var options = _ref.options,
      name = _ref.name,
      label = _ref.label,
      defaultSelected = _ref.defaultSelected,
      callBack = _ref.callBack,
      layout = _ref.layout,
      errorMessage = _ref.errorMessage;
  var radioButtons = options.map(function (option, index) {
    return /*#__PURE__*/React.createElement(BaseRadioButton, {
      label: option.label,
      value: option.value,
      name: name,
      onClick: callBack,
      key: index,
      defaultChecked: option.value === defaultSelected,
      variants: layout
    });
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "hw-block hw-block--mb-medium-2"
  }, /*#__PURE__*/React.createElement("span", {
    className: "hw-label"
  }, label), radioButtons, errorMessage && /*#__PURE__*/React.createElement("div", {
    className: "hw-error-simple hw-error--align-left"
  }, errorMessage));
}
RadioButtonGroup.defaultProps = {
  layout: []
};
RadioButtonGroup.propTypes = {
  name: propTypes.string,
  label: propTypes.string,
  options: propTypes.array,
  callBack: propTypes.func,
  layout: propTypes.arrayOf(propTypes.oneOf(['bounding', 'full', 'horisontal'])),
  errorMessage: propTypes.string
};

function Fieldset(_ref) {
  var legend = _ref.legend,
      selectionControls = _ref.selectionControls,
      children = _ref.children;
  var settings = [{
    name: 'selectionControls',
    value: selectionControls
  }];
  return /*#__PURE__*/React.createElement(FieldsetProvider, {
    value: settings
  }, /*#__PURE__*/React.createElement("fieldset", {
    className: "hw-fieldset"
  }, legend && /*#__PURE__*/React.createElement("legend", {
    className: "hw-fieldset__legend"
  }, legend), /*#__PURE__*/React.createElement("div", {
    className: "hw-fieldset__content"
  }, children)));
}
Fieldset.propTypes = {
  selectionControls: propTypes.arrayOf(propTypes.oneOf(['bounding', 'full', 'horisontal']))
};

function InfoBox(_ref) {
  var title = _ref.title,
      icon = _ref.icon,
      children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "hw-info-box"
  }, icon && /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faInfoSquare,
    className: "hw-info-box__icon",
    size: "lg"
  }), /*#__PURE__*/React.createElement("div", {
    className: "hw-info-box__body"
  }, title && /*#__PURE__*/React.createElement("h3", {
    className: "hw-info-box__title"
  }, title), children));
}
InfoBox.propTypes = {
  title: propTypes.string.isRequired,
  icon: propTypes.bool
};
InfoBox.defaultProps = {
  icon: true
};

function WarningSubtle(_ref) {
  var icon = _ref.icon,
      children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "hw-warning-subtle"
  }, icon && /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faExclamationTriangle,
    className: "hw-warning-subtle__icon"
  }), children);
}
WarningSubtle.propTypes = {
  icon: propTypes.bool
};
WarningSubtle.defaultProps = {
  icon: true
};

function InfoSubtle(_ref) {
  var icon = _ref.icon,
      light = _ref.light,
      children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "hw-info-subtle " + (light ? 'hw-info-subtle--light' : '')
  }, icon && /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faInfoSquare,
    className: "hw-info-subtle__icon"
  }), children);
}
InfoSubtle.propTypes = {
  icon: propTypes.bool,
  light: propTypes.bool
};
InfoSubtle.defaultProps = {
  icon: true,
  light: false
};

function BaseLink(_ref) {
  var href = _ref.href,
      title = _ref.title,
      size = _ref.size,
      type = _ref.type,
      children = _ref.children;
  var modifier = type != '' ? ' hw-link--' + type : '';

  if (size != '') {
    modifier += ' hw-link--' + size;
  }

  return /*#__PURE__*/React.createElement("a", {
    href: href,
    title: title,
    className: 'hw-link' + modifier
  }, children);
}
BaseLink.defaultProps = {
  type: '',
  size: ''
};
BaseLink.propTypes = {
  href: propTypes.string.isRequired,
  title: propTypes.string,
  size: propTypes.oneOf(['small', 'big', '']),
  type: propTypes.oneOf(['solid', 'inverted', 'no-underline', ''])
};

function Link(_ref) {
  var href = _ref.href,
      size = _ref.size,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(BaseLink, {
    href: href,
    size: size
  }, children);
}
Link.defaultProps = {
  size: ''
};
Link.propTypes = {
  href: propTypes.string.isRequired,
  title: propTypes.string,
  size: propTypes.oneOf(['small', 'big', ''])
};

function InvertedLink(_ref) {
  var href = _ref.href,
      title = _ref.title,
      size = _ref.size,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(BaseLink, {
    href: href,
    title: title,
    type: "inverted",
    size: size
  }, children);
}
InvertedLink.defaultProps = {
  size: ''
};
InvertedLink.propTypes = {
  href: propTypes.string.isRequired,
  title: propTypes.string,
  size: propTypes.oneOf(['small', 'big', ''])
};

function SolidLink(_ref) {
  var href = _ref.href,
      title = _ref.title,
      size = _ref.size,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(BaseLink, {
    href: href,
    title: title,
    type: "solid",
    size: size
  }, children);
}
SolidLink.defaultProps = {
  size: ''
};
SolidLink.propTypes = {
  href: propTypes.string.isRequired,
  title: propTypes.string,
  size: propTypes.oneOf(['small', 'big', ''])
};

function SimpleLink(_ref) {
  var href = _ref.href,
      title = _ref.title,
      size = _ref.size,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(BaseLink, {
    href: href,
    title: title,
    type: "no-underline",
    size: size
  }, children);
}
SimpleLink.defaultProps = {
  size: ''
};
SimpleLink.propTypes = {
  href: propTypes.string.isRequired,
  title: propTypes.string,
  size: propTypes.oneOf(['small', 'big', ''])
};

function Block(_ref) {
  var px = _ref.px,
      py = _ref.py,
      mt = _ref.mt,
      mb = _ref.mb,
      elementType = _ref.elementType,
      classList = _ref.classList,
      children = _ref.children;
  var classes = ['hw-block'];
  if (px) classes.push(px === 'on' ? 'hw-block--px' : 'hw-block--px-' + px);
  if (py) classes.push(py === 'on' ? 'hw-block--py' : 'hw-block--py-' + py);
  if (mt) classes.push(mt === 'on' ? 'hw-block--mt' : 'hw-block--mt-' + mt);
  if (mb) classes.push(mb === 'on' ? 'hw-block--mb' : 'hw-block--mb-' + mb);
  if (classList) classes.push(classList);
  return React.createElement(elementType, {
    className: classes.join(' ')
  }, children);
}
var marginSizes = ['small-1', 'small-2', 'small-3', 'small-4', 'medium-1', 'medium-2', 'medium-3', 'medium-4', 'large-1', 'large-2', 'large-3', 'large-4', 'large-5', 'small-1-responsive', 'small-2-responsive', 'small-3-responsive', 'small-4-responsive', 'medium-1-responsive', 'medium-2-responsive', 'medium-3-responsive', 'medium-4-responsive', 'large-1-responsive', 'large-2-responsive', 'large-3-responsive', 'large-4-responsive', 'large-5-responsive'];
Block.defaultProps = {
  elementType: 'div'
};
Block.propTypes = {
  px: propTypes.oneOf(['on', 'responsive', 'mobile']),
  py: propTypes.oneOf(['on', 'responsive']),
  mt: propTypes.oneOf(['on'].concat(marginSizes)),
  mb: propTypes.oneOf(['on'].concat(marginSizes)),
  elementType: propTypes.oneOf(['article', 'div', 'p']),
  classList: propTypes.string
};

function Flex(_ref) {
  var gutterMobile = _ref.gutterMobile,
      gutterDesktop = _ref.gutterDesktop,
      wrap = _ref.wrap,
      variableHeight = _ref.variableHeight,
      children = _ref.children;
  var classes = ['hw-flex'];
  if (gutterMobile) classes.push("hw-flex--gutter-" + gutterMobile + "-mobile");
  if (gutterDesktop) classes.push("hw-flex--gutter-" + gutterDesktop + "-desktop");
  if (wrap) classes.push("hw-flex--" + wrap);
  if (variableHeight) classes.push('hw-flex--variable-height');
  return /*#__PURE__*/React.createElement("div", {
    className: classes.join(' ')
  }, children);
}
Flex.propTypes = {
  gutterMobile: propTypes.oneOf(['large', 'larger', 'largest']),
  gutterDesktop: propTypes.oneOf(['medium', 'large', 'larger', 'largest']),
  wrap: propTypes.oneOf(['twos', 'thirds', 'fourths']),
  variableHeight: propTypes.bool
};

function Media(_ref) {
  var imgUrl = _ref.imgUrl,
      imgFormat = _ref.imgFormat;

  if (!imgUrl) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "hw-card__media hw-card__media-" + imgFormat
  }, /*#__PURE__*/React.createElement("div", {
    className: "hw-card__media-inner ",
    style: {
      backgroundImage: "url(" + imgUrl + ")"
    }
  }));
}

function Overline(_ref2) {
  var overline = _ref2.overline;

  if (!overline) {
    return null;
  }

  return /*#__PURE__*/React.createElement("h5", {
    className: "hw-card__overline"
  }, overline);
}

function Subtitle(_ref3) {
  var subtitle = _ref3.subtitle;

  if (!subtitle) {
    return null;
  }

  return /*#__PURE__*/React.createElement("h5", {
    className: "hw-card__subtitle"
  }, subtitle);
}

function Description(_ref4) {
  var description = _ref4.description;

  if (!description) {
    return null;
  }

  return /*#__PURE__*/React.createElement("p", {
    className: "hw-card__description"
  }, description);
}

function Card(_ref5) {
  var url = _ref5.url,
      title = _ref5.title,
      overline = _ref5.overline,
      subtitle = _ref5.subtitle,
      description = _ref5.description,
      compressed = _ref5.compressed,
      imgUrl = _ref5.imgUrl,
      imgFormat = _ref5.imgFormat,
      target = _ref5.target;
  return /*#__PURE__*/React.createElement("a", {
    className: "hw-card " + (compressed ? 'hw-card--compressed' : ''),
    href: url,
    target: target
  }, /*#__PURE__*/React.createElement(Media, {
    imgUrl: imgUrl,
    imgFormat: imgFormat
  }), /*#__PURE__*/React.createElement("div", {
    className: "hw-card__body"
  }, /*#__PURE__*/React.createElement(Overline, {
    overline: overline
  }), /*#__PURE__*/React.createElement("h3", {
    className: "hw-card__title"
  }, title), /*#__PURE__*/React.createElement(Subtitle, {
    subtitle: subtitle
  }), /*#__PURE__*/React.createElement(Description, {
    description: description
  })));
}
Card.defaultProps = {
  imgFormat: '16-9',
  target: false
};

var ExpandedContext = createContext([{}, function () {}]);

var ExpandedProvider = function ExpandedProvider(_ref) {
  var allowMultiple = _ref.allowMultiple,
      children = _ref.children;

  var _useState = useState({
    allowMultiple: allowMultiple
  }),
      state = _useState[0],
      setState = _useState[1];

  return /*#__PURE__*/React.createElement(ExpandedContext.Provider, {
    value: [state, setState]
  }, children);
};

function Accordion(_ref) {
  var children = _ref.children,
      allowMultiple = _ref.allowMultiple;
  return /*#__PURE__*/React.createElement("ul", {
    className: "hw-accordion"
  }, /*#__PURE__*/React.createElement(ExpandedProvider, {
    allowMultiple: allowMultiple
  }, children));
}
Accordion.propTypes = {
  allowMultiple: propTypes.bool,
  menu: propTypes.bool,
  children: propTypes.arrayOf(propTypes.objectOf(function (child) {
    if (child.type.displayName !== 'AccordionItem') {
      return new Error('Invalid child `' + child.type.displayName + '` supplied to `Accordion`. Validation failed');
    }
  }))
};
Accordion.defaultProps = {
  allowMultiple: true,
  menu: false
};

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function AccordionItem(_ref) {
  var title = _ref.title,
      children = _ref.children,
      expanded = _ref.expanded;

  var _useContext = useContext(ExpandedContext),
      expandedState = _useContext[0],
      setExpandedState = _useContext[1];

  var _useState = useState(),
      triggerHeight = _useState[0],
      setTriggerHeight = _useState[1];

  var _useState2 = useState(),
      contentHeight = _useState2[0],
      setContentHeight = _useState2[1];

  var _useState3 = useState(expanded),
      isExpanded = _useState3[0],
      setIsExpanded = _useState3[1];

  var trigger = createRef();
  var contentRef = createRef();
  var id = "item-" + Math.floor(Math.random() * 10000);
  useEffect(function () {
    if (expanded && !expandedState.allowMultiple && !expandedState.hasSetInitialExpanded) {
      setExpandedState(function (expandedState) {
        return _extends({}, expandedState, {
          open: title,
          hasSetInitialExpanded: true
        });
      });
    }

    setTriggerHeight(trigger.current.offsetHeight);
    setContentHeight(contentRef.current.offsetHeight);
  }, []);

  function toggleItem() {
    if (expandedState.allowMultiple) {
      setIsExpanded(!isExpanded);
    } else {
      setExpandedState(function (expandedState) {
        return _extends({}, expandedState, {
          open: expandedState.open === title ? null : title
        });
      });
    }
  }

  var showExpanded = expandedState.allowMultiple ? isExpanded : expandedState.open === title;
  return /*#__PURE__*/React.createElement("li", {
    className: 'hw-accordion__item' + (showExpanded ? ' hw-accordion__item--expanded' : ''),
    style: {
      height: showExpanded ? triggerHeight + contentHeight + 'px' : triggerHeight + 'px'
    }
  }, /*#__PURE__*/React.createElement("button", {
    className: "hw-accordion__trigger",
    onClick: toggleItem,
    ref: trigger,
    "aria-controls": id,
    "aria-expanded": isExpanded
  }, title, /*#__PURE__*/React.createElement("div", {
    className: "hw-accordion__icon"
  })), /*#__PURE__*/React.createElement("div", {
    id: id,
    className: "hw-accordion__contents",
    ref: contentRef
  }, children));
}
AccordionItem.propTypes = {
  expanded: propTypes.bool,
  title: propTypes.string.isRequired
};
AccordionItem.defaultProps = {
  expanded: false
};

var SuggestionsContext = createContext([{}, function () {}]);

var SuggestionsProvider = function SuggestionsProvider(_ref) {
  var advancedSuggestions = _ref.advancedSuggestions,
      children = _ref.children;

  var _useState = useState({
    advancedSuggestions: advancedSuggestions
  }),
      state = _useState[0],
      setState = _useState[1];

  return /*#__PURE__*/React.createElement(SuggestionsContext.Provider, {
    value: [state, setState]
  }, children);
};

function SearchSuggestion(_ref) {
  var title = _ref.title,
      subTitle = _ref.subTitle,
      href = _ref.href;

  var _useContext = useContext(SuggestionsContext),
      suggestionsState = _useContext[0];

  return /*#__PURE__*/React.createElement("li", {
    className: "hw-search__suggestion",
    "data-hw-search-suggestion": true
  }, /*#__PURE__*/React.createElement("a", {
    className: "hw-search__suggestion-link",
    tabIndex: "-1",
    href: href
  }, /*#__PURE__*/React.createElement("p", {
    className: "hw-search__suggestion-title"
  }, title), suggestionsState.advancedSuggestions && /*#__PURE__*/React.createElement("p", {
    className: "hw-search__suggestion-extra"
  }, subTitle)));
}
SearchSuggestion.propTypes = {
  title: propTypes.string.isRequired,
  href: propTypes.string.isRequired,
  subTitle: propTypes.string
};

function StandaloneSearch(_ref) {
  var label = _ref.label,
      placeholder = _ref.placeholder,
      buttonLabel = _ref.buttonLabel,
      extendedSuggestions = _ref.extendedSuggestions,
      onChange = _ref.onChange,
      onClick = _ref.onClick,
      children = _ref.children;
  var extedendedClass = extendedSuggestions ? '' : 'hw-search__suggestions--simple';

  var _useState = useState(false),
      hasValue = _useState[0],
      setHasValue = _useState[1];

  var inputRef = useRef();

  function handleOnChange(e) {
    setHasValue(inputRef.current.value !== '');

    if (onChange) {
      onChange(e);
    }
  }

  function reset() {
    inputRef.current.value = '';
    setHasValue(false);
  }

  function handleOnclick() {
    onClick(inputRef.current.value);
  }

  return /*#__PURE__*/React.createElement("label", {
    className: "hw-label"
  }, label, /*#__PURE__*/React.createElement("div", {
    className: "hw-search hw-search--standalone " + (hasValue ? 'hw-search--hasvalue' : ''),
    "data-hw-search": true,
    "data-hw-search-placeholders": ""
  }, /*#__PURE__*/React.createElement("div", {
    className: "hw-search__inner"
  }, /*#__PURE__*/React.createElement("input", {
    "data-hw-search-input": true,
    className: "hw-search__input",
    type: "text",
    "aria-label": "Search",
    placeholder: placeholder,
    onChange: function onChange(e) {
      return handleOnChange(e);
    },
    ref: inputRef
  }), /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faSearch,
    className: "hw-search__icon"
  }), /*#__PURE__*/React.createElement("button", {
    className: "hw-search__button-inside",
    "data-hw-search-reset": true,
    onClick: function onClick() {
      return reset();
    }
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faTimesCircle
  }))), /*#__PURE__*/React.createElement(SuggestionsProvider, {
    advancedSuggestions: extendedSuggestions
  }, /*#__PURE__*/React.createElement("ul", {
    className: "hw-search__suggestions " + extedendedClass
  }, children)), /*#__PURE__*/React.createElement("button", {
    type: "submit",
    onClick: function onClick() {
      return handleOnclick();
    },
    className: "hw-button hw-button--primary hw-search__button"
  }, buttonLabel)));
}
StandaloneSearch.defaultProps = {
  extendedSuggestions: false
};
StandaloneSearch.propTypes = {
  label: propTypes.string,
  placeholder: propTypes.string,
  buttonLabel: propTypes.string,
  extendedSuggestions: propTypes.bool,
  onChange: propTypes.func,
  onClick: propTypes.func,
  children: propTypes.arrayOf(propTypes.objectOf(SearchSuggestion))
};

function Trace(_ref) {
  var buttonLabel = _ref.buttonLabel,
      ariaLabel = _ref.ariaLabel,
      placeholder = _ref.placeholder,
      _onChange = _ref.onChange;

  var _useState = useState(''),
      inputValue = _useState[0],
      setInputValue = _useState[1];

  var _useState2 = useState(false),
      hasValue = _useState2[0],
      setHasValue = _useState2[1];

  var classes = '';

  if (hasValue) {
    classes = ' hw-trace--hasvalue';
  }

  function handleInput(e) {
    if (e.target.value) {
      setHasValue(true);
    } else {
      setHasValue(false);
    }

    setInputValue(e.target.value);
  }

  function reset() {
    setInputValue('');
  }

  return /*#__PURE__*/React.createElement("div", {
    "class": 'hw-trace hw-trace' + classes
  }, /*#__PURE__*/React.createElement("div", {
    "class": "hw-trace__inner"
  }, /*#__PURE__*/React.createElement("input", {
    "class": "hw-trace__input ",
    type: "text",
    value: inputValue,
    onChange: function onChange(e) {
      handleInput(e);

      _onChange(e);
    },
    placeholder: placeholder,
    "aria-label": ariaLabel
  }), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "hw-trace__button-inside",
    onClick: reset
  }, ' ', /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faTimesCircle,
    className: ""
  }))), /*#__PURE__*/React.createElement("button", {
    type: "submit",
    "class": "hw-button hw-button--primary hw-trace__button"
  }, buttonLabel));
}
Trace.propTypes = {
  ariaLabel: propTypes.string,
  placeholder: propTypes.string,
  buttonLabel: propTypes.string.isRequired,
  onChange: propTypes.func
};
Trace.defaultProps = {
  onChange: function onChange() {}
};

function Tab(_ref) {
  var items = _ref.items,
      selected = _ref.selected,
      onClick = _ref.onClick;

  var _useState = useState(selected),
      selectedItem = _useState[0],
      setSelectedItem = _useState[1];

  var selectedRef = useRef();
  var markerRef = useRef();
  var tabRef = useRef();
  useEffect(function () {
    if (selectedRef.current) {
      var itemProperties = selectedRef.current.getBoundingClientRect();
      markerRef.current.style.left = itemProperties.left - tabRef.current.getBoundingClientRect().left + tabRef.current.scrollLeft + 'px';
      markerRef.current.style.width = itemProperties.width + 'px';
      horizontalScroll(tabRef.current, selectedRef.current.offsetLeft - tabRef.current.clientWidth / 2 + selectedRef.current.clientWidth / 2);
    } else {
      markerRef.current.style.width = 0;
    }
  }, [selectedItem]);

  function horizontalScroll(containerEl, x) {
    if (containerEl.scroll) {
      containerEl.scroll({
        behavior: 'smooth',
        left: x,
        top: 0
      });
    } else {
      containerEl.scrollLeft = x;
    }
  }

  function handleClick(id) {
    onClick(id);
    setSelectedItem(id);
  }

  function Item(_ref2) {
    var id = _ref2.id,
        content = _ref2.content;
    return /*#__PURE__*/React.createElement("a", {
      className: "hw-tab__item",
      ref: selectedItem === id ? selectedRef : null,
      onClick: function onClick() {
        return handleClick(id);
      },
      role: "tab",
      "aria-selected": id === selectedItem,
      tabIndex: "0"
    }, content);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "hw-tab",
    role: "tablist",
    ref: tabRef
  }, items.map(function (item) {
    return /*#__PURE__*/React.createElement(Item, {
      key: item.id,
      id: item.id,
      content: item.content
    });
  }), /*#__PURE__*/React.createElement("div", {
    className: "hw-tab__marker",
    ref: markerRef
  }));
}
Tab.propTypes = {
  items: propTypes.arrayOf(propTypes.exact({
    id: propTypes.string.isRequired,
    content: propTypes.oneOfType([propTypes.object, propTypes.string]).isRequired,
    selected: propTypes.string
  })).isRequired,
  onClick: propTypes.func.isRequired
};

export { Accordion, AccordionItem, Badge, Block, BoundingCheckbox, BoundingRadioButton, Card, Checkbox, DarkBadge, Dropdown, EmailInput, Fieldset, Flex, InfoBox, InfoSubtle, InvertedLink, LightOutlineButton, Link, NumberInput, PasswordInput, PrimaryButton, PrimaryOutlineButton, RadioButton, RadioButtonGroup, SearchSuggestion, SecondaryButton, SecondaryOutlineButton, SimpleLink, SolidLink, StandaloneSearch, Tab, TextInput, Textarea, Trace, WarningBadge, WarningSubtle as WarningBox, WarningSubtle, WhiteBadge };
//# sourceMappingURL=index.modern.js.map
